import type { LayerRig } from '@/render/rig';
import { useSelectionStore } from '@/state/selection';
import { layersOf, resetLayers, type StationImpl } from '../types';
import { RVT_LAYER, rvtLayer, showContext } from './layer';
import { RevitPanel } from './Panel';
import { useRvtStore } from './rvt';
import { RevitScene } from './Scene';

// the element the selection lights up, on the rig it was lit on
let lit: { rig: LayerRig; id: number } | null = null;
let shown: { rig: LayerRig; context: boolean } | null = null;

export const revit: StationImpl = {
  // the hero is the backdrop here; only the Revit layer answers clicks
  pick: 'none',
  ownsSelection: true,
  enter({ layers, height }) {
    resetLayers(layers, height);
    for (const h of layersOf(layers, (d) => d === 'mep')) h.rig.setVisible(false);
    lit = null;
    shown = null;
    if (useRvtStore.getState().status === 'idle') useRvtStore.getState().loadSample();
  },
  update() {
    const { selected } = useSelectionStore.getState();
    const rig = rvtLayer.rig;
    const { context } = useRvtStore.getState();
    if (rig && (shown?.rig !== rig || shown.context !== context)) {
      showContext(rig, context);
      shown = { rig, context };
    }
    const id = rig && selected?.layer === RVT_LAYER ? selected.expressID : null;
    if (lit && (lit.rig !== rig || lit.id !== id)) {
      if (lit.rig === rig) lit.rig.setElementState(lit.id, null);
      lit = null;
    }
    if (rig && id != null && !lit) {
      rig.setElementState(id, 'highlight');
      lit = { rig, id };
    }
  },
  leave({ layers, height }) {
    resetLayers(layers, height);
    lit = null;
    shown = null;
    useSelectionStore.getState().setFocus(null);
  },
  Panel: RevitPanel,
  Scene: RevitScene,
};
